import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as image from "../../resources/images";
import DonutChart from "../base/DonutChart";
import LineChart from "../base/LineChart";
const ParentStaticDashBoardGraph = () => {
    return (
        <div className="dashboard-grid">
              
                    
            <div className="dashboard-card">
                <h3 className="card-title">Plan Completion Breakdown</h3>
                <div className="card-divider"></div>
                <div className='flexone donutchartwd'>
                    <div className="completion-chart">
                        
                        <DonutChart planCompletion={{ completed: 62, progress: 18, notStarted: 20}} />
        
                        {/* <Chart       data={donuttData} type='doughnut'/> */}
                    </div>
                    <div className="chart-legend">
                        <div className="legend-item">
                            <div className="legend-color" style={{ backgroundColor: ' #85b812' }}></div>
                            <div className="legend-text">62% Completed</div>
                        </div>
                        <div className="legend-item">
                            <div className="legend-color" style={{ backgroundColor: '#a86adb' }}></div>
                            <div className="legend-text">18% In Progress</div>
                        </div>
                        <div className="legend-item">
                            <div className="legend-color" style={{ backgroundColor: '#e46666' }}></div>
                            <div className="legend-text">20% Not Started</div>
                        </div>
                    </div>
                </div>
            </div>
                    
                    
            <div className="dashboard-card">
                <h3 className="card-title">Weekly Activity Trend</h3>
                <div className="card-divider"></div>
               <div className="activity-chart p-0">
                    <LineChart weekActivitData={[{ x: 0, y: 50 }, {x: 1, y: 30}, {x: 2, y: 40}, {x: 3, y: 10}]}/>
                            
                   
                </div>
            </div>
                    
                    
            <div className="dashboard-card">
                <h3 className="card-title">Achievements &amp; Milestones</h3>
                <div className="card-divider"></div>
                <div className="achievement-list">
                    <div className="achievement-item">
                        <img src="https://bloomster.s3.us-east-1.amazonaws.com/badge/Conflict+Resolution+Champion.png" alt="Medal" className="achievement-icon" />
                        <div className="achievement-text">"Focus Hero" badge earned on May 10</div>
                    </div>
                    <div className="achievement-item">
                        <img src={image.fireicon} alt="Fire" className="achievement-icon" />
                        <div className="achievement-text">2 Day Streak Started</div>
                    </div>
                    <div className="achievement-item">
                        <img src="https://bloomster.s3.us-east-1.amazonaws.com/badge/Conflict+Codebreaker.png" alt="Trophy" className="achievement-icon" />
                        <div className="achievement-text">Congrats! All badges earned for Understanding Why Teamwork Matters</div>
                    </div>
                </div>
            </div>
                    
                    
            <div className="dashboard-card okr-section">
                <div className="okr-header">
                    <h2 className="card-title" style={{ marginBottom: ' 0' }}>Plan OKRs Overview</h2>
                    <div className="view-all">
                        <span>View All Plans</span>
                        {/* <img src="../assets/images/img_humbleiconsarrowup.svg" alt="Arrow" width="24" height="24" /> */}
                        <i class="fa-regular fa-arrow-right-long ml-3"></i>
                    </div>
                </div>
                        
                <div className="okr-item">
                    <div className="okr-item-header active" data-target="confident-you">
                                
                        <div className="okr-item-title"><h3 className='h-3'>Confident You: Believe In Yourself</h3></div>
                        {/* <div className="add-button" style={{backgroundColor: '#ffffff', border: 'none'}}> */}
                        <span className="dropdwnicon"><i class="fa-regular fa-angle-down"></i></span>
                        {/* </div> */}
                    </div>
                </div>
                        
                <div className="okr-item">
                    <div className="okr-item-header" data-target="teamwork">
                        <div className="okr-item-title">Understanding Why Teamwork Matters</div>
                        {/* <img src="../assets/images/img_vector_cyan_400.svg" alt="Expand" width="14" height="7" /> */}
                        <span><i class="fa-regular fa-angle-down"></i></span>
                    </div>
                    <div className="okr-item-content active lifeeventlist populattags Child_challenges" id="emotional-you" style={{ display: 'block' }}>
                        <div className="okr-divider"></div>
                        <div className="okr-row">
                            <div className="okr-label">Goal</div>
                            <div className="okr-value">Help Alex Jr build lifelong focus habits through structure and self-awareness.</div>
                        </div>
                        <div className="checkbox">
                            <div className='okr-label'>
                                <div className="Ansoptions">
                                    <label className="selAnslabel ">
                                        {/* <span className="tagName">Boosting Confidence & Resiliance</span> */}
                                        <input type="checkbox" name="knowledgecheck" />
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div className="checkbox-label">KR 1</div>
                            </div>
                            <div className="checkbox-text">Help Alex Jr complete all lessons across 4 modules.</div>
                        </div>
                        <div className="checkbox">
                            <div className='okr-label'>
                                <div className="Ansoptions">
                                    <label className="selAnslabel ">
                                        {/* <span className="tagName">Boosting Confidence & Resiliance</span> */}
                                        <input type="checkbox" name="knowledgecheck" />
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div className="checkbox-label">KR 2</div>
                            </div>
                            <div className="checkbox-text">Help Alex Jr complete all lessons across 4 modules.</div>
                        </div>
                        <div className="checkbox">
                            <div className='okr-label'>                                 <div className="Ansoptions">
                                         
                                <label className="selAnslabel ">
                                    {/* <span className="tagName">Boosting Confidence & Resiliance</span> */}
                                    <input type="checkbox" name="knowledgecheck" />
                                    <span class="checkmark"></span>
                                </label>
                            </div>
                                <div className="checkbox-label">KR 3</div>
                            </div>
        
                            <div className="checkbox-text">Help Alex Jr complete all lessons across 4 modules.</div>
                        </div>
                        <div className="checkbox">
                            <div className='okr-label'>
                                <div className="Ansoptions">
                                    <label className="selAnslabel ">
                                        {/* <span className="tagName">Boosting Confidence & Resiliance</span> */}
                                        <input type="checkbox" name="knowledgecheck" />
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div className="checkbox-label">KR 3</div>
                            </div>
                            <div className="checkbox-text">Help Alex Jr complete all lessons across 4 modules.</div>
                        </div>
                    </div>
                </div>
                        
                <div className="okr-item">
                    <div className="okr-item-header" data-target="teamwork">
                        <div className="okr-item-title">Understanding Why Teamwork Matters</div>
                        <span><i class="fa-regular fa-angle-down"></i></span>
                    </div>
                </div>
                        
                <div className="okr-item">
                    <div className="okr-item-header" data-target="problem-skills">
                        <div className="okr-item-title">Developing Super-Human Problem Skills</div>
                        <span><i class="fa-regular fa-angle-down"></i></span>
                    </div>
                </div>
            </div>
                    
                    
            <div className="dashboard-card schedule-section">
                <div className="schedule-header">
                    <h2 className="card-title" style={{ marginBottom: '0' }}>Plan Schedule</h2>
                    <div className="add-button">
                        <img src="../assets/images/img_vector_white_a700_9x9.svg" alt="Add" width="9" height="9" />
                    </div>
                </div>
                        
                <div className="schedule-days">
                    <div className="day-column">
                        <div className="day-header active">Week</div>
                    </div>
                    <div className="day-column">
                        <div className="day-header inactive">Monday</div>
                    </div>
                    <div className="day-column">
                        <div className="day-header inactive">Tuesday</div>
                    </div>
                    <div className="day-column">
                        <div className="day-header inactive">Wednesday</div>
                    </div>
                </div>
                        
                <div className="week-row" style={{ marginBottom: '0' }}>
                    <div className="week-label">
                        <div className="week-header">5 MAY - 11 MAY</div>
                        <div className="week-number">Week 1</div>
                    </div>
                    <div className="day-cell">
                        <div className="day-date">5 MAY</div>
                    </div>
                    <div className="day-cell">
                        <div className="day-date">6 MAY</div>
                        <div className="day-event">C1: Relationship Building</div>
                        <div className="day-module">M1: Self-Confi...</div>
                    </div>
                    <div className="day-cell">
                        <div className="day-date active">7 MAY</div>
                        <div className="day-event">C1: Relationship Building</div>
                        <div className="day-module">M1: Self-Confi...</div>
                    </div>
                </div>
                        
                <div className="week-row">
                    <div className="week-label">
                        <div className="week-header">5 MAY - 11 MAY</div>
                        <div className="week-number">Week 2</div>
                    </div>
                    <div className="day-cell">
                        <div className="day-date">5 MAY</div>
                    </div>
                    <div className="day-cell">
                        <div className="day-date">6 MAY</div>
                        <div className="day-event">C1: Relationship Building</div>
                        <div className="day-module">M1: Self-Confi...</div>
                    </div>
                    <div className="day-cell">
                        <div className="day-date">8 MAY</div>
                    </div>
                </div>
                        
                <div className="week-row">
                    <div className="week-label">
                        <div className="week-header">5 MAY - 11 MAY</div>
                        <div className="week-number">Week 3</div>
                    </div>
                    <div className="day-cell">
                        <div className="day-date">5 MAY</div>
                    </div>
                    <div className="day-cell">
                        <div className="day-date">6 MAY</div>
                    </div>
                    <div className="day-cell">
                        <div className="day-date">8 MAY</div>
                    </div>
                </div>
                        
                <div className="week-row">
                    <div className="week-label">
                        <div className="week-header">5 MAY - 11 MAY</div>
                        <div className="week-number">Week 4</div>
                    </div>
                    <div className="day-cell">
                        <div className="day-date">6 MAY</div>
                    </div>
                    <div className="day-cell">
                        <div className="day-date">6 MAY</div>
                    </div>
                    <div className="day-cell">
                        <div className="day-date">8 MAY</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default ParentStaticDashBoardGraph;